<div class="page">
  <app-page-header page-title="users.add.pageTitle"></app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <mat-card-title>{{ 'users.add.addTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.addTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate" *ngIf="!userAlreadyExists">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->